import { styled } from '@mui/material/styles';

const BoxContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '40%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.common.white,
  borderRadius: '12px',
  marginTop: theme.spacing(2),
  padding: theme.spacing(4),
  [theme.breakpoints.down('xl')]: {
    width: '55%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '60%',
  },
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
  },
}));

const Title = styled('p')(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 700,
  fontSize: '1.625rem',
  width: '80%',
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: '1.5rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.375rem',
    width: '100%',
  },
}));

const Subtitle = styled('p')(({ theme }) => ({
  textAlign: 'left',
  fontSize: '19px',
  width: '90%',
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const Description4Component = () => {
  return (
    <BoxContainer>
      <Title className="typography-v1-body1">
        Hvorfor lønner det seg å refinansiere gjennom Scoopr?
      </Title>
      <Subtitle className="typography-v1-body1">
        Refinansiering er kort fortalt å{' '}
        <strong>samle flere lån til ett nytt lån med lavere rente</strong>
        .
        <br />
        <br />
        Scoopr samarbeider med flere kjente norske banker for å gjøre det enklere for deg å finne en
        lavere rente.
        <br />
        <br />
        Med lavere rente kan du <strong>betale mindre i måneden, senke totalkostnaden</strong> på
        lånet og <strong>kutte unødvendige kostnader</strong>.
      </Subtitle>
    </BoxContainer>
  );
};

export default Description4Component;
